// extracted by mini-css-extract-plugin
export default {"List":"ProductList_List__+7iOj","Title":"ProductList_Title__AHOND","Btns":"ProductList_Btns__PYcSy","PageNumber":"ProductList_PageNumber__aPAoN"};